import React from 'react';
import PropTypes from 'prop-types';
import CurrencyHelper from '../../../general/js/basket/currency-helper';
import BasketProduct from './basket-product';
import ValidationHelper from '../../../general/js/basket/validation-helper';
import {
    PRODUCT_TAG_CAR,
    PRODUCT_TAG_MOTORCYCLE,
    PRODUCT_TAG_MINIBUS,
    PRODUCT_TAG_COACH
} from '../../../general/js/basket/constants';

export default class BasketProductGroup extends React.Component {
    render() {
        const { productGroup } = this.props;

        // apply validation rules
        const products = ValidationHelper.getPreparedProductsList(productGroup.products);
        const groupHasDifferentTypesOfProducts = this.existOtherProductsThanParkingInGroup(products);

        return (
            <div className="basket-group">
                <h2 className="basket-group__title">
                    {productGroup.title}
                </h2>
                {
                    products.length > 0 ?
                        <div className="basket-group__products">
                            {products.map((product) =>
                                <div key={product.id} className="basket-group__product">
                                    <BasketProduct
                                        product={product}
                                        productGroup={productGroup}
                                        onQuantityUpdate={(quantity) => this.props.onUpdateProductQuantity(product, productGroup, quantity)}
                                        hasBallotConfiguration={this.props.hasBallotConfiguration}
                                        groupHasMoreTypesOfProducts={groupHasDifferentTypesOfProducts} />
                                </div>)}
                        </div> : null
                }
                <div className="basket-group__subtotal">
                    <span>Sub-total:</span>
                    <span>{CurrencyHelper.convertToPounds(productGroup.sum)}</span>
                </div>
            </div>
        );
    }

    existOtherProductsThanParkingInGroup(products) {
        let existOtherProductsThanParking = false;
        products.forEach((productElement) => {
            if (productElement.tag !== PRODUCT_TAG_CAR &&
                productElement.tag !== PRODUCT_TAG_MOTORCYCLE &&
                productElement.tag !== PRODUCT_TAG_MINIBUS &&
                productElement.tag !== PRODUCT_TAG_COACH) {
                existOtherProductsThanParking = true;
            }
        });

        return existOtherProductsThanParking;
    }
}

BasketProductGroup.propTypes = {
    productGroup: PropTypes.object.isRequired,
    onUpdateProductQuantity: PropTypes.func.isRequired,
    hasBallotConfiguration: PropTypes.bool
};
